var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsolationToita8B6Bc4128Cb6Cee9999(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 82,
    viewBox: "0 0 84 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.1309,
    y: 50.2642,
    width: 46.0519,
    height: 20.4802,
    fill: "white",
    stroke: "#08305E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.82136,
    height: 7.82136,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 55.7429 55.9276)",
    fill: "#08305E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.14356,
    height: 3.14356,
    rx: 0.5,
    transform: "matrix(-1 0 0 1 55.209 56.4616)",
    fill: "#E2F0FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.14356,
    height: 3.14356,
    rx: 0.5,
    transform: "matrix(-1 0 0 1 51.637 56.4616)",
    fill: "#E2F0FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.14356,
    height: 3.14356,
    rx: 0.5,
    transform: "matrix(-1 0 0 1 51.637 60.0339)",
    fill: "#E2F0FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.14356,
    height: 3.14356,
    rx: 0.5,
    transform: "matrix(-1 0 0 1 55.209 60.0339)",
    fill: "#E2F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6714 57.8829H38.7963V70.5926H29.6714V57.8829Z",
    fill: "#E2F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3679 56.4014C28.3679 56.1252 28.5918 55.9014 28.8679 55.9014H39.6337C39.9099 55.9014 40.1337 56.1252 40.1337 56.4014V58.47C40.1337 58.7461 39.9099 58.97 39.6337 58.97H28.8679C28.5918 58.97 28.3679 58.7461 28.3679 58.47V56.4014Z",
    fill: "#08305E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.0651,
    cy: 65.1071,
    r: 1.02287,
    fill: "#08305E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1959 36.6652C26.5752 36.2419 27.1168 36 27.6852 36H55.1396C55.708 36 56.2496 36.2419 56.629 36.6652L69.2855 50.787H13.5393L26.1959 36.6652Z",
    fill: "#1EAB66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 71.2444H83.0734",
    stroke: "#08305E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolationToita8B6Bc4128Cb6Cee9999);
export default __webpack_public_path__ + "static/media/isolation_toit.a8b6bc4128cb6cee9999.a8b6bc4128cb6cee99998830934cfaeb.svg";
export { ForwardRef as ReactComponent };